import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCancel } from '@fortawesome/free-solid-svg-icons';
import { util } from '../Util';
import { ApiRoutes } from '../ApiRoutes';
import moment from 'moment';
import { MomentDateFormat } from '../MomentDateFormat';
import BrokerCapacityDisplayText from './BrokerCapacityDisplayText';
import BrokerDateCapacityCalendar from './BrokerDateCapacityCalendar';
import BrokerDefaultCapacityManager from './BrokerDefaultCapacityManager';
import { FormLabel } from '../common/forms/FormElements';

export default class BrokerCapacityButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            brokerDefaultCapacity: {},
            brokerDateCapacities: [],
            brokerCapacityOverview: null,
            isBroker: false,
            anyChanges: false,
        };
    }

    componentDidMount() {
        this.populateState();
    }

    populateState = async () => {
        const { companyId, brokerId, date } = this.props;

        if (!companyId && !brokerId) {
            console.error(
                'BrokerCapacityButton - the company ID should be supplied (as either brokerId or companyId).'
            );
        }

        const startDate = moment()
            .add(-1, 'day')
            .format(MomentDateFormat.ApiUrlRequest);
        const endDate = moment()
            .add(1, 'day')
            .format(MomentDateFormat.ApiUrlRequest);

        const [
            isBroker,
            brokerDefaultCapacity,
            brokerDateCapacities,
            brokerCapacityOverview,
        ] = await Promise.all([
            util.fetch.get(
                ApiRoutes.company.getIsBroker(companyId ?? brokerId)
            ),
            util.fetch.js(
                ApiRoutes.brokerDefaultCapacity.get(companyId ?? brokerId)
            ),
            util.fetch.get(
                ApiRoutes.brokerDateCapacity.getRange(
                    companyId ?? brokerId,
                    startDate,
                    endDate
                )
            ),
            date
                ? util.fetch.js(
                      ApiRoutes.brokerCapacityOverview.forDate(
                          companyId ?? brokerId,
                          moment(date).format(MomentDateFormat.ApiUrlRequest)
                      )
                  )
                : null,
        ]);

        this.setState({
            isBroker,
            brokerDefaultCapacity,
            brokerDateCapacities,
            brokerCapacityOverview,
        });
    };

    onToggleModal = () => {
        const { saving } = this.props;

        if (saving) {
            return;
        }

        const { showModal } = this.state;

        this.setState({ showModal: !showModal, rejectionNotes: null });
    };

    onDefaultCapacityUpdated = (brokerDefaultCapacity) => {
        if (!brokerDefaultCapacity) {
            return;
        }

        this.setState({ brokerDefaultCapacity });
    };

    onDateCapacityUpdated = () => {
        this.populateState();
    };

    render() {
        const { size, className } = this.props;

        const { isBroker, showModal } = this.state;

        if (!isBroker) {
            return null;
        }

        return (
            <div className={className}>
                <Button
                    className="w-100"
                    color="success"
                    type="button"
                    onClick={this.onToggleModal}
                    size={size}
                >
                    <BrokerCapacityDisplayText
                        {...this.props}
                        {...this.state}
                    />
                </Button>

                <Modal
                    isOpen={showModal}
                    toggle={this.onToggleModal}
                    size="xl"
                    fade={false}
                >
                    <ModalHeader toggle={this.onToggleModal}>
                        Capacity Management
                    </ModalHeader>
                    <ModalBody>
                        <BrokerDefaultCapacityManager
                            {...this.props}
                            {...this.state}
                            onDefaultCapacityUpdated={
                                this.onDefaultCapacityUpdated
                            }
                        />
                    </ModalBody>
                    <ModalBody className="light-top-border">
                        <FormLabel text="Per-Day Assignment Capacity - Click to set" />

                        <BrokerDateCapacityCalendar
                            {...this.state}
                            {...this.props}
                            onDateSelected={this.onDateSelected}
                            onPreviousMonthClick={this.onPreviousMonthClick}
                            onNextMonthClick={this.onNextMonthClick}
                            onDateCapacityUpdated={this.onDateCapacityUpdated}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <div className="w-100">
                            <Button
                                type="button"
                                color="warning"
                                onClick={this.onToggleModal}
                                className="w-100"
                                outline
                            >
                                <FontAwesomeIcon
                                    icon={faCancel}
                                    className="mr-1"
                                />
                                Close
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}
